import { node, string } from "prop-types";
import { memo } from "react";
import classNames from "classnames";

interface LabelProps {
  htmlFor: string;
  overrideClass?: string;
  children: any;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function CustomReviewField({ htmlFor, overrideClass, children, ...rest }: LabelProps) {
  return (
    <div>
      <label
        className={classNames(
          `mb-1 text-hotShot text-sm text-left !font-montserrat font-bold break-words `,
          overrideClass
        )}
        htmlFor={htmlFor}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      >
        {children}
      </label>
    </div>
  );
}

CustomReviewField.propTypes = {
  overrideClass: string,
  htmlFor: string,
  children: node.isRequired
};

CustomReviewField.defaultProps = {
  overrideClass: "",
  htmlFor: ""
};

export default memo(CustomReviewField);
